import Const from '../const';
import createReducer from '../config/create_reducer';

const getDefaultState = () => ({
  loading: false,
  user: null,
  error: null,
  emailDetails: {
    emailValidated: false,
    userChangeEmailAddress: false
  },
  userMPIdentify: false
});

const clearedErrors = ({ errorType, state }) => {
  if (!state.error) return null;
  const clearedErrorKeys = Object.keys(state.error).filter((err) => err !== errorType);
  const clearedError = {};
  clearedErrorKeys.forEach((key) => { clearedError[key] = state.error[key]; });
  return Object.keys(clearedError).length > 0 ? clearedError : null;
};

const handleUserChangeEmailAddress = ({ state, email }) => state.emailDetails.email !== undefined
  && state.emailDetails.email !== email;

export const userReducerHandler = {
  [Const.user.loading]: (state) => ({
    ...state,
    loading: true
  }),
  [Const.user.loaded]: (state, { user }) => ({
    ...state,
    user: { ...state.user, ...user },
    loading: false
  }),
  [Const.user.error]: (state, { error }) => ({
    ...state,
    error,
    loading: false
  }),
  [Const.payments.paymentProcessing]: (state, { error }) => ({
    ...state,
    error,
    loading: false
  }),
  [Const.user.emailValidated] : (state, { email, needCheckUserChangeEmailAddress }) => ({
    ...state,
    loading: false,
    emailDetails: {
      ...state.emailDetails,
      emailValidated: true,
      email,
      userChangeEmailAddress: needCheckUserChangeEmailAddress
        ? handleUserChangeEmailAddress({ state, email }) : false
    }
  }),
  [Const.user.emailValidationError]: (state, { error, email }) => ({
    ...state,
    loading:false,
    emailDetails: {
      ...state.emailDetails,
      error,
      email
    }
  }),
  [Const.user.emailValidationErrorClear]: (state) => ({
    ...state,
    emailDetails: {
      ...state.emailDetails,
      error: {}
    }
  }),
  [Const.application.clearError]: (state, { errorType }) => ({
    ...state,
    error: clearedErrors({ errorType, state })
  }),
  [Const.user.emailError]: (state, { error }) => ({
    ...state,
    loading:false,
    emailDetails: {
      ...state.emailDetails,
      error
    }
  }),
  [Const.user.MPIdentify]: (state) => ({
    ...state,
    userMPIdentify: true
  })
};

export default createReducer(getDefaultState(), userReducerHandler);
